import { render } from "./TarifsAbout.vue?vue&type=template&id=6e3d7735&scoped=true"
import script from "./TarifsAbout.vue?vue&type=script&lang=js"
export * from "./TarifsAbout.vue?vue&type=script&lang=js"

import "./TarifsAbout.vue?vue&type=style&index=0&id=6e3d7735&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3d7735"]])

export default __exports__